import { useEffect, useRef } from "react";

export default function useAutoRefresh(onRefresh, { enabled = true, intervalMs = 20000 } = {}) {
  const refreshRef = useRef(onRefresh);

  useEffect(() => {
    refreshRef.current = onRefresh;
  }, [onRefresh]);

  useEffect(() => {
    if (!enabled || typeof refreshRef.current !== "function") return undefined;

    let cancelled = false;
    const run = () => {
      if (cancelled || typeof refreshRef.current !== "function") return;
      Promise.resolve(refreshRef.current()).catch(() => {});
    };

    const handleFocus = () => run();
    const handleVisibility = () => {
      if (document.visibilityState === "visible") run();
    };

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibility);
    const timer = window.setInterval(() => {
      if (document.visibilityState === "visible") run();
    }, Math.max(5000, intervalMs));

    return () => {
      cancelled = true;
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibility);
      window.clearInterval(timer);
    };
  }, [enabled, intervalMs]);
}
